import { zodResolver } from '@hookform/resolvers/zod';
import { FormProvider, useForm } from 'react-hook-form';
import { Outlet } from 'react-router-dom';

import { useUserStore } from '@/common/hooks/UserStore';
import { useSelectedContractForReissueStore } from '@/modules/contract/hooks/useSelectedContractForReissueStore';

import {
  ContractProposalStepSchema,
  ContractProposalStepSchemaForm,
} from '../../schemas/ContractProposalStepSchema';

export function NewContractForm() {
  const { selectedContractForReissue } = useSelectedContractForReissueStore();
  const isReissueMode =
    selectedContractForReissue &&
    Object.keys(selectedContractForReissue).length > 0;
  const { userAccount } = useUserStore();
  const contractProposalHookForm = useForm<ContractProposalStepSchemaForm>({
    mode: 'onChange',
    resolver: zodResolver(ContractProposalStepSchema),
    defaultValues: {
      isDigitalSignature: isReissueMode
        ? selectedContractForReissue?.isDigitalSignature
        : !!userAccount?.Account?.allowDigitalSignature,
    },
  });

  return (
    <FormProvider {...contractProposalHookForm}>
      <Outlet />
    </FormProvider>
  );
}
